module.exports = __webpack_public_path__ + "static/media/8_weblink-VolksuniversiteitGroeneHrt.00a29517.png";